import { render, staticRenderFns } from "./CustomerRecipientsListableManager.vue?vue&type=template&id=2600afc8&scoped=true&"
import script from "./CustomerRecipientsListableManager.vue?vue&type=script&lang=js&"
export * from "./CustomerRecipientsListableManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2600afc8",
  null
  
)

export default component.exports